import { render, staticRenderFns } from "./SharePage.vue?vue&type=template&id=a235f702&scoped=true"
import script from "./SharePage.vue?vue&type=script&lang=js"
export * from "./SharePage.vue?vue&type=script&lang=js"
import style0 from "./SharePage.vue?vue&type=style&index=0&id=a235f702&prod&lang=css"
import style1 from "./SharePage.vue?vue&type=style&index=1&id=a235f702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a235f702",
  null
  
)

export default component.exports